export const reset = `
  font-size: inherit;
  font-family: inherit;
  font-weight: normal;
  line-height: inherit;
  margin: 0;
  padding: 0;
  text-align: center;
`;

export const absoluteCover = `
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
`;

export const pageLimit = `
  max-width: 1370px;
  margin: 0 auto;
`;

export const mixFont = (group, isMobile) => `
  ${group.family ? `font-family: ${group.family};` : ""}
  ${group.size ? `font-size: ${group.size}px;` : ""}
  ${group.color ? `color: ${group.color};` : ""}
  ${group.height ? `line-height: ${group.height}px;` : ""}
  ${group.spacing ? `letter-spacing: ${group.spacing}px;` : ""}
  ${group.weight ? `font-weight: ${group.weight}` : ""};
  ${group.desktop && !isMobile ? mixFont(group.desktop) : ""};
  ${group.mobile && isMobile ? mixFont(group.mobile) : ""};
`;

export const mixFontObj = (group, isMobile) => {
  const fontStyles = {
    fontFamily: group && group.family ? group.family : "",
    fontSize: group && group.size ? `${group.size}px` : "",
    color: group && group.color ? group.color : "",
    lineHeight: group && group.height ? `${group.height}px` : "",
    letterSpacing: group && group.spacing ? `${group.spacing}px` : "",
    fontWeight: group && group.weight ? group.weight : ""
  };
  const mobileStyles = group.isMobile &&
    isMobile && {
      ...fontStyles,
      ...mixFontObj(group.mobile)
    };
  const desktopStyles = group.isMobile &&
    !isMobile && {
      ...fontStyles,
      ...mixFontObj(group.desktop)
    };

  return {
    ...fontStyles,
    ...mobileStyles,
    ...desktopStyles
  };
};
